import { AuthConfig, Provider, SignOutOptions } from '../types/types'
import cookieHandler from '../handlers/cookieHandler'
import tokenHandler from '../handlers/tokenHandler'
import { AccessTokenData } from '../types/tokenTypes'

// Only used when not proxied (local development). Proxied sites log out via /account/logout,
// which reads the id token server-side.
export default (config: AuthConfig) => {
  const cookie = cookieHandler()
  const token = tokenHandler(config)

  const getProvider = (): Provider => {
    const accessToken = token.getToken<AccessTokenData>(cookie.getAccessToken())
    if (accessToken?.is_punchout) return 'dustin_punchout'
    return accessToken?.identity_provider?.name === 'azureAd' ? 'azure_ad' : 'okta'
  }

  return (options: SignOutOptions = {}): void => {
    let url = `${config.authServerUrl}/${getProvider()}/signout`

    if (options.returnUrl) {
      url = `${url}${url.indexOf('?') === -1 ? '?' : '&'}`
      url = `${url}return_url=${options.returnUrl}`
    }

    if (options.bounceUrl) {
      url = `${url}${url.indexOf('?') === -1 ? '?' : '&'}`
      url = `${url}bounce_url=${options.bounceUrl}`
    }

    cookie.clearTokens()
    cookie.clearCookiesOnSignOut()

    location.href = url
  }
}
